var render = function render(){var _vm=this,_c=_vm._self._c;return _c('system-tabs',{attrs:{"section":"/system/tickets"}},[_c('el-card',{staticClass:"contains-table",attrs:{"shadow":"always"}},[_c('project-list',{attrs:{"scope":"system"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }